import { red, grey } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const grey900 = grey['900'];
const red500 = red['500'];

const primaryColor = '#13679a';
const primaryShadow = '0 14px 26px -12px #13679a30, 0 4px 23px 0px #13679a4f, 0 8px 10px -5px #13679a1a';
const primarySmallShadow = '0 2px 2px 0 #13679a30, 0 3px 1px -2px #13679a4f, 0 1px 5px 0 #13679a1a';
const primaryBackground = 'linear-gradient(60deg, #216ceb, #1b5ece)';

export default createTheme({
    palette: {
        primary: {
            main: primaryColor
        },
        secondary: {
            main: red500,
        },
    },
    button: {
        shadows: {
            primary: primaryShadow,
            primarySmall: primarySmallShadow
        }
    },
    sideBar: {
        shadows: {
            primary: primaryShadow
        }
    },
    appBar: {
        height: 57,
        color: primaryColor
    },
    drawer: {
        width: 230,
        color: grey900
    },
    raisedButton: {
        primaryColor: primaryColor,
    },
    toolbar: {
        height: 160
    },
    cardHeader: {
        primary:{
            background: primaryBackground,
            boxShadow: primaryShadow
        }
    }
});





// WEBPACK FOOTER //
// ./node_modules/@int/signature/assets/themes/ultra-theme.js